import { createSlice } from "@reduxjs/toolkit";
import { LocalStoragePersistanceService } from "persist/LocalStorage";
import { UserState } from "state/types";

const initialState: UserState = {
  user: null,
  jwt: "",
};
const localStore = new LocalStoragePersistanceService()
export const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      const { user, jwt } = action.payload;
      state.jwt = jwt;
      state.user = user;
      localStore.setItem('user', user)
      localStore.setItem('jwt', jwt)
    },
  },
});

// Actions
export const { setUserData } = usersSlice.actions;

// Thunks

export const loginUser = (userInfo) => async (dispatch) => {
  console.log("INDISDE LOGIN USER");
  dispatch(setUserData(userInfo));
};

export default usersSlice.reducer;
